import { queryOptions } from '@tanstack/react-query';
import { trendingVideoAPIClient } from '../trendingVideoAPIClient';
import { TRENDING_VIDEO_QUERY_KEYS } from './keys';
import type { ListTrendingVideosRequest } from './types';

export const TRENDING_VIDEO_QUERIES = {
  list: (params?: ListTrendingVideosRequest) =>
    queryOptions({
      queryKey: TRENDING_VIDEO_QUERY_KEYS.list(params),
      queryFn: () => trendingVideoAPIClient.list(params),
    }),
  detail: (videoId: string) =>
    queryOptions({
      queryKey: TRENDING_VIDEO_QUERY_KEYS.detail(videoId),
      queryFn: () => trendingVideoAPIClient.get(videoId),
    }),
};
